/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';

import RenderPrismicContent from '../components/RenderPrismicContent';
import { getBackgroundClass } from '../utils/styling';

import getJuniorCircuitsPageContent from '../redux/actions/v2/junior-circuits-page-actions';

const JuniorCircuitsPage = props => {
    const { juniorCircuitsPageV2 } = props;

    return (
        <div className={`${getBackgroundClass(juniorCircuitsPageV2.content)}`}>
            <RenderPrismicContent contentSlices={juniorCircuitsPageV2.content} />
        </div>
    );
};

JuniorCircuitsPage.getInitialProps = async ({ store }) => {
    const { juniorCircuitsPageV2 } = store.getState();

    if (!(juniorCircuitsPageV2 && juniorCircuitsPageV2.loaded)) {
        await store.dispatch(getJuniorCircuitsPageContent());
    }
};

const mapStateToProps = ({ juniorCircuitsPageV2 }) => {
    return { juniorCircuitsPageV2 };
};

const mapDispatchToProps = {
    getJuniorCircuitsPageContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(JuniorCircuitsPage);
